import { Route, Routes } from "react-router-dom";

import { FeatureFlagsProvider } from "@av/apps/common-apps/platform/components/FeatureFlagsProvider";
import JobsApp from "@av/apps/public/jobs/JobsApp";
import { NotFoundPage } from "@av/components/templates/layouts/errors/types/NotFoundPage";
import { TrackingProvider } from "@av/components/utilities/trackings/TrackingProvider";
import { getAntdLocale } from "@av/config/i18n/antdLocales";
import { i18nInstance } from "@av/config/i18n/i18n-bundle";
import { LoginLayout } from "@av/pages/auth/LoginLayout";
import { LoginHome } from "@av/pages/auth/pages/LoginHome";
import { MagicLink } from "@av/pages/auth/pages/magic-link/MagicLink";
import { MagicLinkLandingPage } from "@av/pages/auth/pages/magic-link/MagicLinkLandingPage";
import { RequireAuth } from "@av/pages/auth/RequireAuth";
import { AppResolver } from "@av/routes/AppResolver";

/**
 * Root routing component that orchestrates the multi-app routing system.
 *
 * Each registered app receives the same props interface and is rendered
 * under its own route path with wildcard matching for internal routing.
 */
export function RootRoutes() {
  const antdLocale = getAntdLocale(i18nInstance);

  return (
    <Routes>
      {/*  Static routes */}
      <Route
        path="/login-with-magic-link"
        element={
          <FeatureFlagsProvider>
            <MagicLinkLandingPage />
          </FeatureFlagsProvider>
        }
      />
      <Route path="/login" element={<LoginLayout />}>
        <Route index element={<LoginHome />} />
        <Route path="magic-link" element={<MagicLink />} />
      </Route>
      <Route path="/job-board/*" element={<JobsApp currentAntdLocale={antdLocale} />} />

      {/*  Authentication required for app specific routes */}
      <Route element={<RequireAuth />}>
        <Route
          path="/*"
          element={
            <TrackingProvider>
              <FeatureFlagsProvider>
                <AppResolver />
              </FeatureFlagsProvider>
            </TrackingProvider>
          }
        />
      </Route>

      {/*  Default fallback */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
